import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoPersoStep6Bloc from "../blocs/info-perso/InfoPersoStep6Bloc";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep6Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
      
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Téléchargez vos justificatifs</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep6Bloc />
        </div>
          <GeneralDataProtectionBloc/>
      </div>
  
    )

}